export default {"src":"/_next/static/media/icon_hamburger_helpcenter.ed1602e4.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};